module.exports = __webpack_public_path__ + "img/invest_b1.cd11ad16.png";